import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import SearchInput from "../../elements/SearchInput";

var SearchForm = function SearchForm(_ref) {
  var action = _ref.action,
      method = _ref.method,
      searchInput = _ref.searchInput,
      suggestion = _ref.suggestion;
  var getClassName = getClassNameFactory(SearchForm.displayName);
  return /*#__PURE__*/React.createElement("form", {
    className: getClassName(),
    action: action,
    method: method
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "input"
    })
  }, /*#__PURE__*/React.createElement(SearchInput, searchInput)), suggestion ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "suggestion"
    })
  }, "Search instead for ", /*#__PURE__*/React.createElement("a", {
    href: suggestion.href
  }, suggestion.text)) : null);
};

SearchForm.displayName = "SearchForm";
SearchForm.methods = ["get", "post"];
SearchForm.propTypes = {
  /**
   * Form action attribute value
   */
  action: PropTypes.string.isRequired,

  /**
   * Form method attribute
   */
  method: PropTypes.oneOf(SearchForm.methods),

  /**
   * Optional config object to initialise SearchInput component
   */
  searchInput: PropTypes.object,

  /**
   * Optional object containing alternative search suggestion, link href and text
   */
  suggestion: PropTypes.object
};
SearchForm.defaultProps = {
  action: "",
  method: "get",
  searchInput: {
    name: "q",
    typeahead: true,
    typeaheadUrl: "",
    value: ""
  }
};
export default SearchForm;